import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IEventState } from '@shared/models';
import * as Response from '@shared/models/events/event.response.type';
import { fetchPopularEventList, fetchUpcomingEventList } from '../queries';

const state: IEventState = {
    popular: [],
    fetchingPopular: false,
    upcoming: [],
    fetchingUpcoming: false,
};

const eventDashboardSlice = createSlice({
    name: 'event-dashboard',
    initialState: state,
    reducers: {
        setPopularEventList: (state, { payload }: PayloadAction<Response.IPopularEventListResponse>) => {
            state.popular = payload;
        },
        setUpcomingEventList: (state, { payload }: PayloadAction<Response.IUpcomingEventListResponse>) => {
            state.upcoming = payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPopularEventList.pending, (state) => {
            state.fetchingPopular = true;
        });
        builder.addCase(fetchPopularEventList.rejected, (state) => {
            state.fetchingPopular = false;
        });
        builder.addCase(fetchPopularEventList.fulfilled, (state) => {
            state.fetchingPopular = false;
        });
        builder.addCase(fetchUpcomingEventList.pending, (state) => {
            state.fetchingUpcoming = true;
        });
        builder.addCase(fetchUpcomingEventList.rejected, (state) => {
            state.fetchingUpcoming = false;
        });
        builder.addCase(fetchUpcomingEventList.fulfilled, (state) => {
            state.fetchingUpcoming = false;
        });
    },
});

export const { setPopularEventList, setUpcomingEventList } = eventDashboardSlice.actions;
export const eventRootReducer = eventDashboardSlice.reducer;
